import { MuiThemeProvider, createTheme } from '@material-ui/core/styles';
import HttpsRedirect from 'react-https-redirect';
import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Invoice from './payments/Invoice';
import Receipt from './payments/Receipt';

function buildMuiTheme() {
	const primaryColor = '#000000';

	return createTheme({
		overrides: {
			MuiInput: {
				underline: {
					'&:before': {
						borderBottom: `1px solid rgb(240, 240, 240)`,
					},
					'&:hover:not($disabled):not($focused):not($error):before': {
						borderBottom: `2px solid ${primaryColor}`,
					},
					'&$disabled:before': {
						borderBottom: `1px dotted ${primaryColor}`,
					},
				},
			},
			MuiAppBar: {
				root: {
					backgroundColor: '#ffffff',
					boxShadow:
						'0px 1px 1px 0px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 0px 1px -1px rgba(0,0,0,0.12)',
				},
			},
			MuiButton: {
				contained: {
					boxShadow:
						'0px 1px 2px 0px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 1px -1px rgba(0,0,0,0.12)',
				},
			},
			MuiCheckbox: {
				root: {
					color: `${primaryColor}`,
				},
			},
			MuiListItem: {
				root: {
					'&$selected': {
						backgroundColor: 'rgba(0, 0, 0, 0.06)',
					},
				},
			},
			MuiFormLabel: {
				root: {
					color: '#a8a8a8',
					fontWeight: 'lighter',
				},
			},
			MuiRadio: {
				root: {
					color: 'rgba(0, 0, 0, 0.54);',
				},
			},
		},
		typography: {
			allVariants: {
				color: '#333333',
			},
			h5: {
				textTransform: 'uppercase',
				fontSize: '1em',
			},
			fontFamily: [
				'Source Sans',
				'Open Sans',
				'-apple-system',
				'BlinkMacSystemFont',
				'Segoe UI',
				'Roboto',
				'Arial',
				'sans-serif',
				'"Apple Color Emoji"',
				'"Segoe UI Emoji"',
				'"Segoe UI Symbol"',
			].join(','),
		},

		palette: {
			primary: {
				main: `${primaryColor}`,
				contrastText: '#fff',
			},
			secondary: {
				main: '#2986C6',
				contrastText: '#fff',
			},
			text: {
				primary: '#333333',
				secondary: '#ffffff',
			},
			background: {
				paper: '#FCF8F3',
				default: '#FCF8F3',
			},
		},
	});
}

class App extends Component {
	constructor(props) {
		super(props);
		this.v4muiTheme = buildMuiTheme();
	}

	render() {
		return (
			<MuiThemeProvider theme={this.v4muiTheme}>
				<HttpsRedirect>
					<BrowserRouter>
						<Switch>
							<Route
								exact
								path="/invoices/:_invoice"
								component={Invoice}
							/>
							<Route
								exact
								path="/view-receipt/:_invoice"
								component={Receipt}
							/>
						</Switch>
					</BrowserRouter>
				</HttpsRedirect>
			</MuiThemeProvider>
		);
	}
}

export default App;
